 $(".slick-slider").slick({
      slidesToShow: 4,
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev testi-left-arro"><span style="font-size: 60px;">&#8249;</span></button>',
      nextArrow: '<button type="button" class="slick-next testi-right-arro"><span style="font-size: 60px;">&#8250;</span></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            prevArrow: '<button type="button" class="slick-prev testi-left-arro"><span style="font-size: 40px;">&#8249;</span></button>',
            nextArrow: '<button type="button" class="slick-next testi-right-arro"><span style="font-size: 40px;">&#8250;</span></button>',
          }
        },
        {
          breakpoint: 600, 
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
          }
        }
      ]
    });

/* blog slider*/

$(document).ready(function() {
  $('.blog-carousel').owlCarousel({
    items: 1, // Default number of items
    margin: 20,
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    nav: true,
    dots: true,
    responsive: {
      0: { items: 1 },      
      600: { items: 1 },   
      1000: { items: 1 }    
    }
  });
});


/* instagram slider*/


setTimeout(function() {
  console.log('instagram slider here');
jQuery('div#insta-feed .instafeed-new-layout-wrapper').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    nav:false,
    autoplay:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
}, 5000);  





